import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import PERIODICIDADE from "../../data/Periodicidade";
import WS from '../../config/Ws';
import PAGES from '../../config/Pages';
import Requisitions from '../../utils/requisitions/Requisitions';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import Alert from "../../components/alert/Alert";

const URL_SAVE = WS.planos.save;

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe,
      ativo: props.detalhe ? props.detalhe.ativo : 0
    }
    this.getPeriodicidade = this.getPeriodicidade.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
   const target = event.target;
   const value = target.type === 'checkbox' ? target.checked : target.value;
   const name = target.name;

   this.setState({
     [name]: value
   });
 }

  getPeriodicidade() {
    const self = this;
    let val = '';
    Object.entries(PERIODICIDADE).forEach(
      ([key, value]) => {
        if(value.value === self.props.detalhe.periodicidade){
          val = value;
        }
      }
    );
    return val;
  }

  handleSubmit (e){
    const formData = new FormData(e.target);
    const plano = formData.get('plano');
    const valor = formData.get('valor');
    const periodicidade = formData.get('periodicidade');
    const descricao = formData.get('descricao');

    let modal = new Alert();
    var _self = this;
    const { salvoSucesso, msgCamposObrigatoriosVideos } = this.state.strings;

    var object = FormDataToJson(formData);
    object.ativo = formData.get('ativo') ? 1 : 0;

    const {
      atencao,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    if(plano !== '' && (valor !== '' || periodicidade !== '')){
      Requisitions({
        url:URL_SAVE,
        data: object,
        sucess:function(data){
          var msg;
          _self.props.modal.close();
          _self.props.history.push(PAGES.planos);
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }else{
      let msg = {
        title: atencao,
        text:msgCamposObrigatoriosVideos
      };
      Dialog.create(msg);
    }

    e.preventDefault();
  }

  render (){

    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} /> : '';

    const
    {
      nomePlano,
      periodicidade,
      descricaoPlano,
      descricaoPlanoCompleto,
      valorPlano,
      digiteAqui,
      qtdParcelas,
      salvar,
      idSuperlogica
    } = this.state.strings;

    const plano = this.props.detalhe ? this.props.detalhe.nome : '';
    const valor = this.props.detalhe ? this.props.detalhe.valor : '';
    const periodicidadeVal = this.props.detalhe ? this.getPeriodicidade(): '';
    const descricao = this.props.detalhe ? this.props.detalhe.descricao : '';
    const descricao_completa = this.props.detalhe ? this.props.detalhe.descricao_completa : '';
    const max_parcelas = this.props.detalhe ? this.props.detalhe.max_parcelas : '';
    const ativo = this.state.ativo;
    const blockEdit = this.props.detalhe;
    const superlogica_id = this.props.detalhe ? this.props.detalhe.superlogica_id : '';

    return (
      <div>
        <MainTitle title="Cadastro de plano"></MainTitle>
        <form className="" onSubmit={this.handleSubmit}>
          {id}
          <div>
            <div className="pure-u-24-24">
              <div className='checkItem'>
                <input type="checkbox" name="ativo" checked={this.state.ativo} onChange={this.handleInputChange} />
                <span>Ativar/ Desativar plano</span>
              </div>
              <br />
            </div>
            <div className="pure-u-12-24">
              <TextInput value={plano} name="plano" title={nomePlano+"*"} placeholder={digiteAqui}></TextInput>
            </div>
            <div className="pure-u-6-24">
              <TextInput value={valor} name="valor" title={valorPlano} placeholder={digiteAqui}></TextInput>
            </div>
            <div className="pure-u-6-24">
              <TextInput value={max_parcelas} name="max_parcelas" title={qtdParcelas} placeholder={digiteAqui}></TextInput>
            </div>
            <div className="pure-u-15-24">
              <Select value={periodicidadeVal} title={periodicidade+'*'} name='periodicidade' options={PERIODICIDADE}/>
            </div>
            <div className="pure-u-9-24">
              <TextInput value={superlogica_id} name="superlogica_id" title={idSuperlogica} placeholder={digiteAqui}></TextInput>
            </div>
          </div>
          <div className="">
            <TextArea value={descricao} name="descricao" title={descricaoPlano+"*"} placeholder=""></TextArea>
          </div>
          <div className="">
            <TextArea value={descricao_completa} name="descricao_completa" title={descricaoPlanoCompleto} placeholder=""></TextArea>
          </div>
          <div className="box-right-button"><Button type="submit" text={salvar}classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/planos/Page.js